import { render, staticRenderFns } from "./fajas-colombianas-wholesale-sign-up.vue?vue&type=template&id=23b84f6b"
import script from "./fajas-colombianas-wholesale-sign-up.vue?vue&type=script&lang=js"
export * from "./fajas-colombianas-wholesale-sign-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports